import type {ReactElement} from 'react';
import {TemplateNameInput} from '@EmailMakerReact/layout/email-maker-nav/components/template-name-input/template-name-input';
import type {EmailMakerControlProps} from '../../right-panel-registry.types';
import styles from './template-name-input-control.module.scss';

export function TemplateNameInputControl(_props: EmailMakerControlProps): ReactElement {
  return (
    <div className={styles.wrapper}>
      <TemplateNameInput />
    </div>
  );
}
